import React from 'react';
/**
 * Created by alvinoktavianus (https://github.com/alvinoktavianus)
 * on 02/04/18
 */

import styles from './styles.css';

const English = () => {
  return (
    <div className={styles['tnc-wrapper']}>
      <ol type="I">
        <b>
          <li>THE PARTIES</li>
        </b>
        <ol type="1">
          <li>
            The parties involved under this T&amp;C are::
            <ol type="a">
              <li>
                PT Moka Teknologi Indonesia, hereinafter will be referred to as
                “<b>MOKA</b>”;
              </li>
              <li>
                PT Visionet Internasional, hereinafter will be referred to as “
                <b>OVO</b>” or “<b>VI</b>”; and
              </li>
              <li>
                Merchant, as referred to in Merchant Digital Application Form,
                which is an integral part of this T&amp;C.
              </li>
            </ol>
          </li>
          <li>
            MOKA, OVO, and Merchant jointly will be referred to as “Parties” and
            respectively will be referred to as “Party”.
          </li>
        </ol>
        <b>
          <li>INTRODUCTION</li>
        </b>
        The Parties hereby explain that:
        <ol type="1">
          <li>
            Merchant has agreed with the Terms and Conditions of the use of Moka
            App, which was shown on Moka App and completed the Merchant Digital
            Application Form as provided on Moka App;
          </li>
          <li>
            Merchant has agreed to be able to receive payment via Moka App, from
            its customers who use OVO Payment feature on its OVO App; and
          </li>
          <li>
            therefore, Merchant must, firstly, read and agree with the following
            terms and conditions:
          </li>
        </ol>
        <b>
          <li>DEFINITIONS AND INTERPRETATIONS</li>
        </b>
        <ol type="1">
          <li>
            Unless otherwise expressly specified under this T&amp;C, the
            following terms have the following definitions:
            <ol type="a">
              <li>
                "<b>OVO App</b>" is a mobile application that has features to
                process payment electronically that is made, owned, developed,
                designed, provided, and managed by OVO.
              </li>
              <li>
                "<b>Moka App</b>" is a mobile application with cloud based
                cashier system, which can be used by Merchant to record purchase
                transaction of its Products performed by its Customers, which is
                owned, developed, designed, provided, and managed by MOKA with
                name, logo, and/or other mark as notified by MOKA from time to
                time.
              </li>
              <li>
                "<b>Force Majeure</b>" is any event that occurs beyond the
                control, capability, and prediction of the Party who experiences
                it and such occurence is not caused by any wrongdoing or
                negligence of such Party, to be recogized as event of force
                majeure is, including but not limited to; strike, embargo,
                chaos, war, fire, explosion, sabotage, storm, flood, earthquake,
                or the enactment of laws and regulatons or decree of any
                authorized institutions that cause the termination of the whole
                or a part of this T&amp;C.
              </li>
              <li>
                "<b>Merchant Digital Application Form</b>" atau "<b>Form</b>" is
                a form that must be completed by Merchant to be able to use
                features on Moka App, which consists of; data or information of
                Merchant, including but not limited to; address, licenses,
                and/or corporate information of Merchant, and bank account
                number of Merchant.
              </li>
              <li>
                "<b>Business Days</b>" are working days starting from Monday to
                Friday, excluding Saturday, Sunday, and national public holiday
                as determined by the Government of the Republic of Indonesia.
              </li>
              <li>
                "<b>Merchant Discount Rate</b>" atau "<b>MDR</b>" is fee charged
                to Merchant on the provision of Service by OVO. The amount of
                MDR is deducted by OVO from the value of Transaction in
                percentage. The amount of percentage or MDR taken for every
                sucessful Transaction is 1.5% (one point five percent) from the
                value of the Transaction.
              </li>
              <li>
                "<b>OVO Payment</b>" is a payment feature that can be accessed
                by Customers via OVO App whereby Customers can pay for Product
                by using server based electronic money and point rewards issued
                by OVO.
              </li>
              <li>
                "<b>Product</b>" is goods and/or services provided, offerred,
                and/or sold by Merchant to Customers.
              </li>
              <li>
                "<b>Transaction</b>" is any payment transaction for Products
                performed by Customers by using OVO Payment.
              </li>
              <li>
                "<b>Customers</b>" is customers of Merchant.
              </li>
              <li>
                "<b>Cut-Off Time</b>" is the deadline for the recording of all
                Transactions by VI for all Transactions performed on a day.
                Cut-Off Time will be used as the time basis for VI to make
                payment of Transaction fund to Merchant, in this case Cut-Off
                Time will be at 23.59 WIB
              </li>
            </ol>
          </li>
        </ol>
        <b>
          <li>SCOPE OF T&C</li>
        </b>
        <ol type="1">
          <li>
            Merchant hereby agrees to accept every Transaction, via Moka App,
            performed by Customers with OVO Payment via OVO App, so Merchant can
            receive such Transaction and record it in its Moka App;
          </li>
          <li>
            MOKA and Merchant hereby agree that OVO will process every
            Transaction of Product payment made with OVO Payment that is
            recorded by Merchant in Moka App.
          </li>
          <li>
            MOKA hereby undertakes to settle Transaction funds to Merchant for
            all Transactions made with OVO Payment.
          </li>
        </ol>
        <b>
          <li>MERCHANT GENERAL REQUIREMENTS</li>
        </b>
        <ol type="1">
          <li>
            To be able to accept Transaction performed with OVO Payment,
            Merchant must:
            <ol type="1">
              <li>
                have an active business activity and/or complete lincenses that
                is still valid;
              </li>
              <li>have an active bank account; and</li>
              <li>complete Form and agree to this T&amp;C.</li>
            </ol>
          </li>
          <li>
            Merchant hereby expresses that any information and data provided to
            MOKA in Form are the correct information and data and Merchant is
            responsible for the correctness of such information and data.
          </li>
          <li>
            Merchant hereby agrees that information and data of Merchant
            submitted by Merchant to MOKA in Form will be submitted by MOKA to
            OVO for the purpose of processing of Transaction made with OVO
            Payment.
          </li>
        </ol>
        <b>
          <li>OBLIGATIONS AND RIGHTS OF THE PARTIES</li>
        </b>
        <ol type="1">
          <li>
            Notwithstanding Merchant’s other obligations under this T&amp;C,
            Merchant is obliged to:
            <ol type="a">
              <li>
                accept every Transaction in accordance with procedure and
                provisions as stipulated by OVO, and not permitted to refuse or
                charge a surcharge/additional fee to Customers in any form
                whatsoever for making Transaction;
              </li>
              <li>
                provide and present payment evidence to Customers for
                Transaction which has been successfully made;
              </li>
              <li>
                ensure the confidentiality of data or information on Transaction
                including but not limited to; purchase invoice and Customers’
                information, and not to disclose such information to any third
                parties for any purposes whatsoever;
              </li>
              <li>
                ensure the validity and authenticity of every Transaction;
              </li>
              <li>
                provide records, supporting documents or evidences, and/or
                Transaction entries properly and accountably that must be
                presented and/or provided at any time to MOKA for verification
                or audit purposes of the validity and authenticity of
                Transaction; and
              </li>
              <li>
                not carry out false or fraud Transaction or actions that may
                breach the laws and not have a cooperation with fraudster(s)
                that may cause loss to Customers, MOKA, OVO, and/or other third
                parties.
              </li>
            </ol>
          </li>
          <li>
            Notwithstanding Merchant’s other rights under this T&amp;C, Merchant
            is entitled to:
            <ol type="a">
              <li>
                receive payment of Transaction fund, after deducted with MDR,
                from MOKA;
              </li>
              <li>
                receive daily Transaction report from MOKA for a day at the
                latest of 2 (two) Business Days (D+2) from Cut-Off Time on such
                day; and
              </li>
              <li>
                receive periodical training from MOKA in relation with
                Transaction acceptance, OVO App, and OVO Payment.
              </li>
            </ol>
          </li>
          <li>
            Notwithstanding MOKA’s other obligations under this T&amp;C, MOKA is
            obliged to:
            <ol type="a">
              <li>
                pay Transaction fund, after deducted with MDR, to Merchant; and
              </li>
              <li>
                provide daily Transaction report to Merchant for a day at the
                latest of 2 (two) Business Days from Cut-Off Time of such day.
              </li>
            </ol>
          </li>
          <li>
            Notwitstanding MOKA’s other rights under this T&amp;C, MOKA is
            entitled to:
            <ol type="a">
              <li>
                receive MDR from Merchant by directly deducting the Transaction
                fund received from every Transaction that is successfully made;
              </li>
              <li>
                Suspend the payment of Transaction fund to Merchant, in the
                event of any allegation or indication of a fraud Transaction,
                Transaction that is performed by violating laws, and/or
                Transaction as referred to in article XV of this T&C;
              </li>
              <li>
                perform audit or verification by checking on and/or requesting
                records, supporting documents or evidences, and/or Transaction
                entries from Merchant; and
              </li>
              <li>
                take necessary legal proceeding if there is an occurence of
                situation as referred to in Article XV of this T&amp;C.
              </li>
            </ol>
          </li>
          <li>
            Notwithstanding OVO’s other obligations under this T&amp;C, OVO is
            obligated to process every Transaction made with OVO Payment so
            Merchant can accept such Transaction.
          </li>
          <li>
            Notwithstanding OVO’s other rights under this T&amp;C, OVO is
            entitled to:
            <ol type="a">
              <li>determine the procedure of Transaction acceptance;</li>
              <li>
                determine the procedure of the settlement or payment of
                Transaction fund from MOKA to Merchant; and
              </li>
              <li>
                determine the acceptance or refusal of Merchant registration as
                OVO merchant.
              </li>
            </ol>
          </li>
        </ol>
        <b>
          <li>CORRECTION OF TRANSACTION</li>
        </b>
        <ol type="1">
          <li>
            The Parties hereby agree that the calculation under the Transaction
            daily report issued by MOKA is the calculation that will be the
            basis of the payment of Transaction fund.
          </li>
          <li>
            MOKA is entitled to perform a correction to Transaction, if the
            amount to be paid to Merchant is over or not in accordance with the
            amount as stated in the Transaction daily report issued by MOKA.
          </li>
          <li>
            Notwithstanding the provision under letter a) above, Merchant may
            file an objection to MOKA on the difference of amount to be paid,
            the objection must be supplemented with supporting documents that
            are acceptable to MOKA.
          </li>
        </ol>
        <b>
          <li>PAYMENT PROVISION</li>
        </b>
        Based on the Transaction daily report issued by MOKA, MOKA must pay the
        Transaction fund, after deducted with MDR, to Merchant at the latest of
        2 (two) Business Days from the latest Cut-Off Time, to Merchant’s bank
        account as stated in Form.
        <b>
          <li>TERM AND TERMINATION</li>
        </b>
        The provisions under this T&amp;C will be effective by the time Merchant
        has agreed to this T&amp;C by clicking “Agree” on the page where this
        T&amp;C is shown on MOKA App and this T&amp;C will apply as long as the
        cooperation between MOKA and OVO is still in force.
        <b>
          <li>LIMITATION OF RESPONSIBILITIES</li>
        </b>
        Merchant hereby releases OVO and MOKA from:
        <ol type="a">
          <li>
            any responsibility in relation to Product as provided or sold by
            Merchant to Customers;
          </li>
          <li>
            any losses arising out of error or interference of internet
            connection or communication network that may cause failure to
            perform Transaction;
          </li>
          <li>
            any legal suit or claim from Customers, or other third parties in
            relation with Merchant’s negligence or wrongdoing in performing its
            business;
          </li>
          <li>
            any legal suit or claim from any party whomsoever that arises out of
            the use or disclosure of Transaction and/or Customers information
            that is conducted ilegally or by breaching this T&C; and/or
          </li>
          <li>
            any risk caused by the misinformation provided by Merchant in Form.
          </li>
        </ol>
        <b>
          <li>DISPUTE RESOLUTION</li>
        </b>
        <ol type="1">
          <li>
            The Parties agree to settle any dispute arising out of the
            implementation of this T&amp;C amicably and by deliberation to reach
            a consensus.
          </li>
          <li>
            If the Parties fail to reach an amicable resolution and consensus
            then one Party may file an application to settle such dispute to the
            authorized court. Hereby, the Parties agree to settle the dispute in
            the South Jakarta District Court.
          </li>
          <li>
            Excluded from the circumstance and provisions under paragraphs a)
            and b) above, MOKA and/or OVO, at any time, may take any legal
            proceeding, either in criminal and/or civil courts, for any
            llegation of violation in implementing this T&amp;C.
          </li>
        </ol>
        <b>
          <li>USE OF NAME, TRADEMARK, AND LOGO</li>
        </b>
        <ol type="1">
          <li>
            In accordance with the standard terms and conditions of trademark
            usage as stipulated, respectively, by OVO and MOKA, Merchant must
            use the name, logo and mark of “OVO” or other name, logo, or mark as
            determined by OVO, at any time, in Merchant’s business location.
          </li>
          <li>
            Merchant must ensure that anypromotion material provided by MOKA in
            relation to the Transaction acceptance with OVO Payment, is clearly
            displayed and can be seen by the public, in Merchant’s business
            locations.
          </li>
          <li>
            Any intelectual property rights that belong to one Party will remain
            be owned by such Party. None in this T&amp;C can be interpreted as a
            transfer of intelectual property rights from one Party to the other
            Party.
          </li>
        </ol>
        <b>
          <li>FORCE MAJEURE</li>
        </b>
        <ol type="1">
          <li>
            In the event of Force Majeure, the Party who experiences the event
            of Force Majeure must notify the other Party in writing on the
            occurence of such event at the latest of 7 (seven) calendar days
            since the occurence of such event.
          </li>
          <li>
            The event of Force Majeure can be the reason for the time extension
            provided for the performance of obligation of the Party who
            experiences such event, hence the Party who does not experience the
            event of Force Majeure must release the Party who experiences it
            from any sanction arising out of the delay of its performance.
          </li>
        </ol>
        <b>
          <li>MISCELLANEOUS</li>
        </b>
        <ol type="1">
          <li>
            Merchant represents and warrants that any information provided in
            Form is the correct information, hence, Merchant is fully
            responsible for the accuracy of such information.
          </li>
          <li>
            Each Party may not transfer the whole or a part of its rights and
            obligations under this T&C to any third parties without a prior
            written approval from the other Party.
          </li>
          <li>
            Each Party is responsible for any tax arising out of the
            implementation of this T&amp;C in accordance with the provisions of
            the prevailing laws and regulations.
          </li>
          <li>
            This T&C is effective and binding to Parties along with their
            successors.
          </li>
          <li>
            This T&C is made in bilingual, i.e. Bahasa Indonesia and English,
            the English version only applies as a translation of the Bahasa
            Indonesia version. Hence, if there is a difference in interpreting
            both versions then the Bahasa Indonesia version will prevail.
          </li>
        </ol>
        <b>
          <li>ABUSE OF TRANSACTION</li>
        </b>
        <ol type="1">
          <li>
            Merchant is responsible to prevent Transaction that is made by and
            for sole benefit of Merchant, its representatives, agents,
            employees, or contractors (“<b>Representative</b>”), or Transaction
            that violates, or may inflict loss to MOKA and/or OVO, including but
            not limited to; Transaction made by Merchant and/or its
            Representative and/or other parties who have cooperation with
            Merchant in Merchant’s Outlet for Merchant’s own Products.
          </li>
          <li>
            If MOKA and/or OVO find or suspect that there is Transaction or the
            use of OVO App or MOKA App for the purpose as referred to in
            paragraph a) above then OVO or MOKA is entitled to suspend the
            payment of Transaction fund, which is indicated to be resulted from
            Transaction as referred to in paragraph a) above, to Merchant.
          </li>
          <li>
            Merchant and/or its Representatives are prohibited to modifiy
            Electronic Device and use Service ilegally or for other purpose that
            violates the law, including but not limited to; fraud and other
            ilegal Transaction.
          </li>
          <li>
            If the event as referred to in paragraph c) above occurs then
            Merchant and/or Representative must immediately inform MOKA or OVO
            of such occurence.
          </li>
          <li>
            The payment suspension of Transaction fund as referred to in
            paragraph b) will be held for 14 (fourteen) Working Days, if after
            such period is exceeded and Merchant is not proven to have violated
            the provision under paragraph a) above then MOKA will end the
            suspension and pay the suspended Transaction fund to Merchant.
          </li>
          <li>
            If Merchant is proven to have performed violation as referred to in
            paragraph a) above then MOKA, upon its sole discretion, is entitled
            to determine the settlement that is deemed to be fit by MOKA for the
            suspended Transaction fund.
          </li>
          <li>
            Merchant hereby releases MOKA and OVO from every suit, charge,
            and/or claim if MOKA enforces its right to determine the settlement
            of the suspended Transaction fund as long as MOKA can prove, outside
            the court, that Merchant, indeed, performs the violation as referred
            to in paragarah a) above.
          </li>
        </ol>
        <b>
          <li>CLOSING</li>
        </b>
        <ol type="1">
          <li>
            Merchant has read, understood, and agreed to all provisions under
            this T&amp;C.
          </li>
          <li>
            By clicking the “Agree” option on the page where this T&amp;C is
            shown on Moka App then Merchant is deemed to have agreed to all
            provisions under this T&amp;C.
          </li>
        </ol>
      </ol>
    </div>
  );
};

export default English;
